import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styles from './TooltipManager.scss';
import {
  openTolltip,
  closeTolltip,
} from '../../store/modules/TooltipManagerActions';
import Tooltip from './Tooltip';
const rootClassName = styles.rootClassName;

class TooltipManager extends Component {
  render() {
    return (
      <div className={rootClassName}>
        {this.props.tooltipManager.tooltips.map((tooltipState, index) => {
          return <Tooltip state={tooltipState} key={index} />;
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tooltipManager: state.tooltipManager,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openTolltip,
      closeTolltip,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TooltipManager);
